<form [formGroup]="form" (ngSubmit)="confirmar()"
    class="grid grid-cols-1 w-full"> <!-- md:grid-cols-2 lg:grid-cols-3 gap-x-4 md:gap-x-8 gap-y-4 -->
    <div class="flex flex-col">
        <label class="pb-2" for="razon">Nombre *</label>
        <input pInputText id="razon" formControlName="razon_social" placeholder="Ingrese la razón social" />
        <app-input-error [control]="form.get('razon_social')"></app-input-error>
    </div>

    <!-- 
    <div class="flex flex-col">
        <label for="nombre">Nombre*</label>
        <input pInputText id="nombre" formControlName="nombre" placeholder="Ingrese el nombre" class="w-full" />
        <app-input-error [control]="form.get('nombre')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="poliza">Póliza*</label>
        <input pInputText type="number" id="poliza" formControlName="poliza" placeholder="Ingrese el número de póliza"
            class="w-full" />
        <app-input-error [control]="form.get('poliza')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="desde">Vigencia desde</label>
        <p-datepicker [showIcon]="true" [iconDisplay]="'input'" id="desde" formControlName="desde" dateFormat="dd/mm/yy"
            placeholder="dd/mm/aaaa" class="w-full" appendTo="body" [style]="{width: '100%'}"
            [inputStyle]="{width: '100%'}" />
    </div>

    <div class="flex flex-col">
        <label for="hasta">Vigencia hasta*</label>
        <p-datepicker [showIcon]="true" [iconDisplay]="'input'" id="hasta" formControlName="hasta" dateFormat="dd/mm/yy"
            placeholder="dd/mm/aaaa" class="w-full" appendTo="body" [style]="{width: '100%'}"
            [inputStyle]="{width: '100%'}" />
        <app-input-error [control]="form.get('hasta')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="tipo">Tipo de seguro</label>
        <p-select [showClear]="true" id="tipo" formControlName="tipo" placeholder="Seleccione una opción"
            [options]="opcionesSelect.tipo" class="w-full" appendTo="body" />
    </div>

    <div class="flex flex-col">
        <label for="alcance">Alcance de cobertura</label>
        <p-select [showClear]="true" id="alcance" formControlName="alcance" placeholder="Seleccione una opción"
            [options]="opcionesSelect.alcance" class="w-full" appendTo="body" />
    </div>
    -->

    <div class="flex justify-end gap-3 col-span-1 md:col-span-2 lg:col-span-3 w-full pt-3">
        <button pButton type="button" label="Cancelar" class="p-button-secondary" (click)="cancelar()">
        </button>
        <button pButton type="submit" label="Confirmar" [disabled]="form.invalid">
        </button>
    </div>
</form>